import config from "../config";
import { serviceInstance } from "../axiosInterceptor/requestHandler";

const settingService = {
  //Alerts&Alarms
  //Get
  getEvents: async () => {
    return await serviceInstance
      .get(`${config.baseurl}/Utility/GetEvent`)
      .then(({ data, status }) => {
        return data;
      });
  },
  getMappedEvents: async (id) => {
    return await serviceInstance
      .get(`${config.baseurl}/Utility/MapEvent`)
      .then(({ data, status }) => {
        return data;
      });
  },

  //Post
  createEvent: async (data) => {
    return await serviceInstance
      .post(`${config.baseurl}/Utility/CreateEvent?eventName=${data.eventName}`)
      .then(({ data, status }) => {
        return data;
      });
  },

  mapEvent: async (data) => {
    return await serviceInstance
      .post(`${config.baseurl}/Utility/SetNotifyProcess`, data)
      .then(({ data, status }) => {
        return data;
      });
  },

  //Put
  editMappedEvent: async (data) => {
    return await serviceInstance
      .put(`${config.baseurl}/Utility/EditMapEvent`, data)
      .then(({ data, status }) => {
        return data;
      });
  },

  //Delete
  removeMappedEvent: async (id) => {
    return await serviceInstance
      .delete(`${config.baseurl}/Utility/UnMapEvent?mappedId=${id}`)
      .then(({ data, status }) => {
        return data;
      });
  },

  //

  //Categories settings

  //get
  getAllVariationTypes: async () => {
    return await serviceInstance
      .get(`${config.baseurl}/get-variations`)
      .then(({ data }) => {
        return data;
      });
  },


  addCategory: async (data) => {
    return await serviceInstance
      .post(`${config.baseurl}/create-category`, data)
      .then(({ data }) => {
        return data;
      });
  },

  addVariationName:async (data) => {
    return await serviceInstance
      .post(`${config.baseurl}/CreateECShopVariation`, data)
      .then(({ data }) => {
        return data;
      });
  },


 
  


  addBrand: async (data) => {
    return await serviceInstance
      .post(`${config.baseurl}/ECProductBrand/Add`, data)
      .then(({ data }) => {
        return data;
      });
  },

  //PUT
  editBrand: async (id, data) => {
    return await serviceInstance
      .put(`${config.baseurl}/ECProductBrand/${id}`, data)
      .then(({ data }) => {
        return data;
      });
  },
  //

  getStockControl: async (id, date, pageData) => {
    return await serviceInstance
      .get(
        `${config.baseurl}/FeatureControl/StockControlDetails?startDate=${date?.start}&endDate=${date?.end}&Page=${pageData.page}&PageLimit=${pageData.pageLimit}&query=${pageData?.query}&range=5&depotId=${id}`
      )
      .then(({ data, status }) => {
        return data;
      });
  },

  getPriceControl: async (id, date, pageData) => {
    return await serviceInstance
      .get(
        `${config.baseurl}/FeatureControl/GetPriceControlDetails?startDate=${date?.start}&endDate=${date?.end}&Page=${pageData.page}&PageLimit=${pageData.pageLimit}&query=${pageData?.query}&range=5&customPrice=true&depotId=${id}`
      )
      .then(({ data, status }) => {
        return data;
      });
  },

  updateExemptionLists: async (data) => {
    return await serviceInstance
      .post(`${config.baseurl}/FeatureControl/ExemptCustomer`, data)
      .then(({ data, status }) => {
        return data;
      });
  },

  DeleteStockControl: async (id) => {
    return await serviceInstance
      .put(
        `${config.baseurl}/FeatureControl/DeleteStockControl?controlId=${id}`,
        {}
      )

      .then(({ data, status }) => {
        return data;
      });
  },

  DeleteStopSaleControl: async (id) => {
    return await serviceInstance
      .delete(
        `${config.baseurl}/FeatureControl/DeleteStopSaleControl?controlId=${id}`
      )
      .then(({ data, status }) => {
        return data;
      });
  },

  DeleteLimitControl: async (id) => {
    return await serviceInstance
      .delete(
        `${config.baseurl}/FeatureControl/DeleteLimitControl?controlId=${id}`
      )
      .then(({ data, status }) => {
        return data;
      });
  },

  DeletePriceControl: async (id) => {
    return await serviceInstance
      .delete(
        `${config.baseurl}/FeatureControl/DeletePriceControl?controlId=${id}`
      )
      .then(({ data, status }) => {
        return data;
      });
  },

  getExemption: async (data) => {
    return await serviceInstance
      .get(
        `${config.baseurl}/FeatureControl/GetExemption/${data.controlId}?controlId=${data.controlId}`
      )
      .then(({ data, status }) => {
        return data;
      });
  },

  getPreExemption: async (id) => {
    return await serviceInstance
      .get(`${config.baseurl}/Depot/ProductSaleCollection?depotId=${id}`)
      .then(({ data, status }) => {
        return data;
      });
  },

  controlWizard: async (id, type, Action) => {
    return await serviceInstance
      .put(
        `${config.baseurl}/FeatureControl/UpdateControlStatus?id=${id}&controlType=${type}&controlStatus=${Action}`,
        {}
      )
      .then(({ data, status }) => {
        return data;
      });
  },

  getLimitControl: async () => {
    return await serviceInstance
      .get(`${config.baseurl}/FeatureControl/GetLimitControlDetails`)
      .then(({ data, status }) => {
        return data;
      });
  },

  getStopControl: async (date, pageData) => {
    return await serviceInstance
      .get(
        `${config.baseurl}/FeatureControl/GetAllStopSalesDetails?startDate=${date?.start}&endDate=${date?.end}&Page=${pageData.page}&PageLimit=${pageData.pageLimit}&query=${pageData?.query}&range=5`
      )
      .then(({ data, status }) => {
        return data;
      });
  },

  createStopControl: async (data) => {
    return serviceInstance
      .post(`${config.baseurl}/FeatureControl/StopSaleControl`, data)
      .then(({ data }) => data);
  },

  createStockControl: async (data) => {
    return serviceInstance
      .post(`${config.baseurl}/FeatureControl/AddStockControl`, data)
      .then(({ data }) => data);
  },

  editStockControl: async (data) => {
    return serviceInstance
      .put(`${config.baseurl}/FeatureControl/ModifyStockControl`, data)
      .then(({ data }) => data);
  },

  // getDetailsStock: async (id) => {
  //   return serviceInstance
  //     .get(`${config.baseurl}/FeatureControl/StockControlDetails?depotId=${id}`)
  //     .then(({ data }) => data);
  // },

  editLimitControl: async (data) => {
    return serviceInstance
      .put(`${config.baseurl}/FeatureControl/EditLimitControl`, data)
      .then(({ data }) => data);
  },

  createPriceControl: async (data) => {
    return serviceInstance
      .post(`${config.baseurl}/FeatureControl/AddPriceControl`, data)
      .then(({ data }) => data);
  },

  createLimitControl: async (data) => {
    return serviceInstance
      .post(`${config.baseurl}/FeatureControl/LimitControl`, data)
      .then(({ data }) => data);
  },
};

export default settingService;
